import { Component, OnInit, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-relatorio-laudo-padrao',
  templateUrl: './relatorio-laudo-padrao.component.html',
  styleUrls: ['./relatorio-laudo-padrao.component.scss']
})
export class RelatorioLaudoPadraoComponent implements OnInit, OnChanges {

  @Input() template;
  elements = [];
  elementsObs = [];

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    if(this.template && this.template.elements) {
      this.elements = this.template.elements.filter( e => e.name.toLowerCase().search('obs') == -1 )
      this.elementsObs = this.template.elements.filter( e => e.name.toLowerCase().search('obs') > -1 && e.type == 'TEXT' )
    }

  }

}
